module.exports = __webpack_public_path__ + "static/media/img_sendero.6293dd2d.jpg";